<div class="wrapper">
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <div class="heading"></div>
  <div
    class="ui vertical basic segment heading"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <div
      class="containerNew"
      *ngFor="let director of pendingHistory; let i = index"
    >
      <div class="contents">
        <div class="content_name">
          <div class="information">
            <div style="width: 130px" class="info">
              <p>Date Added</p>
              <h4 style="white-space: nowrap">
                {{ director?.dateCreated | date: "d MMM, y h:mm a" }}
              </h4>
            </div>
            <div style="width: 130px" class="info">
              <p>
                {{
                  director?.status === "DISCARDED"
                    ? "Date Discarded"
                    : "Date Verified"
                }}
              </p>
              <h4 style="white-space: nowrap">
                {{ (director?.dateApproved | date: "d MMM, y h:mm a") || "--" }}
              </h4>
            </div>
            <div style="width: 190px" class="info">
              <p>Added By</p>
              <h4>{{ director?.createdBy | createdBy }}</h4>
            </div>
            <div style="width: 120px" class="info">
              <p>Action Type</p>
              <div class="pills">
                <esl-pills
                  [color]="getColorForLabel(director?.status)"
                  [textColor]="getColorTextForLabel(director?.status)"
                  label="{{ director?.status }}"
                ></esl-pills>
              </div>
            </div>
          </div>
          <div
            *ngIf="director?.status === 'UNVERIFIED' && director?.remark"
            class="ui message"
            style="
              background-color: #fff0f0;
              display: flex;
              padding: 8px 16px;
              color: #505050;
              margin-top: 0;
              padding: 2px 16px;
              align-items: center;
              box-shadow: none !important;
              border: 1px solid #fff0f0 !important;
              width: 95%;
            "
          >
            <h6
              style="
                font-size: 10px;
                font-weight: 400;
                align-items: center;
                display: flex;
              "
            >
              <span
                style="
                  margin-right: 9px;
                  margin-left: 5px;
                  color: #505050;
                  margin-top: 6px;
                  text-transform: capitalize;
                "
              >
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.99915 5.7507V7.6257M1.34753 9.31352C0.914839 10.0635 1.45612 11.0007 2.32199 11.0007H9.67632C10.5422 11.0007 11.0835 10.0635 10.6508 9.31352L6.97361 2.93977C6.54068 2.18935 5.45763 2.18935 5.02469 2.93977L1.34753 9.31352ZM5.99915 9.1257H6.0029V9.12945H5.99915V9.1257Z"
                    stroke="#505050"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg> </span
              >{{ director?.remark }}
            </h6>
          </div>
        </div>
      </div>
      <div class="action_button">
        <img
          src="assets/icons/View.svg"
          style="cursor: pointer"
          (click)="viewHistory(director)"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="View"
          alt=""
        />
      </div>
    </div>
    <app-no-record-found
      *ngIf="pendingHistory && pendingHistory.length < 1"
    ></app-no-record-found>
  </div>
  <!-- <div class="containerNew heading">
      <div class="contents">
        <div class="content_name">
          <div class="information">
            <div class="info">
              <p>Date Added</p>
              <h4>24 May, 2020 12:15 pm</h4>
            </div>
            <div class="info">
              <p>Date Verified</p>
              <h4>24 May, 2020 12:15 pm</h4>
            </div>
            <div class="info">
              <p>Added By</p>
              <h4>Alimi Brother</h4>
            </div>
            <div class="info">
              <p>Action Type</p>
              <div class="pills">
                <esl-pills
                  color="#5FD3A4"
                  textColor="#FFFFFF"
                  label="VERIFIED"
                ></esl-pills>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="action_button">
        <img src="assets/icons/View.svg" alt="" />
      </div>
    </div>
    <div class="containerNew">
      <div class="contents">
        <div class="content_name">
          <div class="information">
            <div class="info">
              <p>Date Added</p>
              <h4>24 May, 2020 12:15 pm</h4>
            </div>
            <div class="info">
              <p>Date Verified</p>
              <h4>24 May, 2020 12:15 pm</h4>
            </div>
            <div class="info">
              <p>Added By</p>
              <h4>Alimi Brother</h4>
            </div>
            <div class="info">
              <p>Action Type</p>
              <div class="pills">
                <esl-pills
                  color="#FB4037"
                  textColor="#FFFFFF"
                  label="UNVERIFIED"
                ></esl-pills>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="action_button">
        <img src="assets/icons/View.svg" alt="" />
      </div>
    </div>
    <div class="containerNew">
      <div class="contents">
        <div class="content_name">
          <div class="information">
            <div class="info">
              <p>Date Added</p>
              <h4>24 May, 2020 12:15 pm</h4>
            </div>
            <div class="info">
              <p>Date Verified</p>
              <h4>24 May, 2020 12:15 pm</h4>
            </div>
            <div class="info">
              <p>Added By</p>
              <h4>Alimi Brother</h4>
            </div>
            <div class="pills">
              <esl-pills
                color="#E4E5E7"
                textColor="#505050"
                label="DISCARDED"
              ></esl-pills>
            </div>
          </div>
        </div>
      </div>
      <div class="action_button">
        <img src="assets/icons/View.svg" alt="" />
      </div>
    </div> -->
  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui labeled button">
          <div class="ui tiny icon button" (click)="getPage(1)">
            <i class="refresh icon"></i>
          </div>
          <a class="ui basic label"> {{ totalItems }} Record(s) </a>
        </div>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="mini"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
</div>
